import {createTheme} from '@mui/material/styles';
import {buildButtonTokensTheme} from "./buttonTokens.theme";
import {buildTypographyTheme} from "./typography.theme";
import {buildComponentsTheme} from "./components.theme";
import {buildLightPalette} from "./palette.theme";
import {brand} from "../brand";

const themeWithBreakpoints = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            smPlus: 680,
            tablet: 760,
            md: 960,
            mdPlus: 1100,
            lg: 1280,
            lgPlus: 1600,
            xl: 1920,
        },
    },
});

export function buildTheme() {
    const baseTheme = createTheme(
        themeWithBreakpoints,
        buildButtonTokensTheme(brand.colors),
        buildTypographyTheme(themeWithBreakpoints),
        buildComponentsTheme(themeWithBreakpoints),
    );

    return createTheme(
        baseTheme,
        { palette: buildLightPalette(brand.colors) }
    );
}